import { render, staticRenderFns } from "./store-bind-log.vue?vue&type=template&id=8cb3cef4&scoped=true&"
import script from "./store-bind-log.vue?vue&type=script&lang=js&"
export * from "./store-bind-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb3cef4",
  null
  
)

export default component.exports